module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("156Wm"))).then(() => parcelRequire('fThBo'));